class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 200);
  }

  onToggle() {

    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Add hover functionality but remove the automatic close on mouseleave
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    
    // Remove the mouseleave listener that causes auto-closing
    // this.mainDetailsToggle.addEventListener('mouseleave', this.onFocusOut.bind(this));
    
    // Track if menu was opened by click vs hover
    this.mainDetailsToggle.addEventListener('click', () => {
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('data-clicked', 'true');
      } else {
        this.mainDetailsToggle.removeAttribute('data-clicked');
      }
    });
    
    // Add document click handler to close mega menu when clicking outside
    document.addEventListener('click', this.handleDocumentClick.bind(this));
    
    // Add event listener to close mega menu when header icons are clicked
    const headerIcons = document.querySelector('.header__icons');
    if (headerIcons) {
      headerIcons.addEventListener('click', this.closeAllMegaMenus.bind(this));
    }
    
    // Add a click event listener to the summary element to handle toggle behavior
    const summaryElement = this.mainDetailsToggle.querySelector('summary');
    if (summaryElement) {
      summaryElement.addEventListener('click', (event) => {
        // If the menu is already open, prevent the default toggle behavior and close it manually
        if (this.mainDetailsToggle.hasAttribute('open')) {
          event.preventDefault();
          this.close();
          this.mainDetailsToggle.removeAttribute('data-clicked');
        }
      });
    }
  }
  
  // New method to close all mega menus
  closeAllMegaMenus() {
    const openMegaMenus = document.querySelectorAll('header-menu details[open]');
    openMegaMenus.forEach(menu => {
      menu.removeAttribute('open');
      menu.querySelector('summary').setAttribute('aria-expanded', false);
      menu.removeAttribute('data-clicked');
    });
  }
  
  handleDocumentClick(event) {
    // Check if any mega menu is open
    const openMegaMenus = document.querySelectorAll('header-menu details[open]');
    if (openMegaMenus.length === 0) return;
    
    // Check if click was outside the header and mega menu area
    const headerArea = document.querySelector('.header-wrapper');
    if (headerArea && !headerArea.contains(event.target)) {
      // Close all open mega menus
      this.closeAllMegaMenus();
    }
  }

  onMouseEnter() {
    const openMegaMenu = document.querySelector('header-menu details[open]');
  
    // ✅ Run hover logic ONLY if some other mega menu is already open
    if (!openMegaMenu || openMegaMenu === this.mainDetailsToggle) {
      return; // No menu is open OR this menu is already open → do nothing
    }
  
    // ✅ Don't switch if current open menu was clicked
    if (openMegaMenu.hasAttribute('data-clicked')) {
      return;
    }
  
    // ✅ Proceed with 800ms delay before switching
    this.isHovered = true;
  
    this.hoverTimer = setTimeout(() => {
      if (this.isHovered) {
        // Close previously open mega menu
        openMegaMenu.removeAttribute('open');
        openMegaMenu.querySelector('summary').setAttribute('aria-expanded', false);
        openMegaMenu.removeAttribute('data-clicked');
  
        // Open this menu
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
        this.mainDetailsToggle.removeAttribute('data-clicked');
  
        // Trigger animations
        if (!this.animations) this.animations = this.content.getAnimations();
        this.animations.forEach((animation) => animation.play());
      }
    }, 200);
  }
  

  onMouseLeave() {
    this.isHovered = false;
    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = null;
    }
  }
  
  
  

  // Override the parent class onFocusOut to prevent auto-closing
  onFocusOut() {
    // Only close if it was opened by hover, not by click
    if (!this.mainDetailsToggle.hasAttribute('data-clicked')) {
      setTimeout(() => {
        // Check if focus is completely outside the header area
        const headerArea = document.querySelector('.header-wrapper');
        if (headerArea && !headerArea.contains(document.activeElement)) {
          this.close();
        }
      }, 200);
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
